import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AsyncStateOverlayModule } from '../../core/async-state/async-state.module';
import { CustomTranslatorModule } from '../../shared/i18n/custom-translate.module';
import { ConfirmRemoveMonitoredUsersModalComponent } from './components/confirm-remove-monitored-user-modal/confirm-remove-monitored-user-modal.component';
import { MonitoredUserAnalysisComponent } from './components/user-details/monitored-user-analysis/monitored-user-analysis.component';
import { MonitoredUserDetailsComponent } from './components/user-details/monitored-user-details/monitored-user-details.component';
import { ConfirmChangeFlowModalComponent } from './components/user-details/monitored-user-flow/confirm-change-flow-modal/confirm-change-flow-modal.component';
import { MonitoredUserFlowComponent } from './components/user-details/monitored-user-flow/monitored-user-flow.component';
import { MonitoredUserSubmissionsListComponent } from './components/user-details/monitored-user-submissions-list/monitored-user-submissions-list.component';
import { InviteMonitoredUserComponent } from './components/users-list/invite-monitored-user/invite-monitored-user.component';
import { UsersListComponent } from './components/users-list/users-list.component';
import { usersUiRoutes } from './users-ui.routes';
import { AppSharedModule } from '../../shared/shared.module';
import { SharedModule } from 'ngx-esprio-shared';
import { UserDetailsComponent } from './components/user-details/user-details.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(usersUiRoutes),
    AppSharedModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    AsyncStateOverlayModule,
    CustomTranslatorModule,
    MatTableModule,
    MatSortModule,
    MatInputModule,
    CdkTableModule,
    BsDatepickerModule,
    InlineSVGModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    MonitoredUserAnalysisComponent,
    MonitoredUserDetailsComponent,
    UserDetailsComponent,
    UsersListComponent,
    ConfirmRemoveMonitoredUsersModalComponent,
    MonitoredUserSubmissionsListComponent,
    MonitoredUserFlowComponent,
    ConfirmChangeFlowModalComponent,
    InviteMonitoredUserComponent,
  ],
  exports: [RouterModule],
})
export class UsersUiModule {}
